import React, { useEffect, useState } from "react";
import * as math from "mathjs";
import "./index.scss";
import { useExtraTool } from "@/contexts/ExtraToolContext";
import Draggable from "react-draggable";
import { TimesIcon } from "@/icons";

const Calculator = () => {
  const [input, setInput] = useState<string>(""); // Kullanıcının girdiği ifadeler
  const [result, setResult] = useState<string | number>(""); // Hesaplanan sonuç
  const nodeRef = React.useRef<HTMLDivElement>(document.createElement("div"));

  const { isCalculatorOpen, closeCalculator } = useExtraTool();
  useEffect(() => {
    setResult("");
    setInput("");
  }, []);
  console.log(isCalculatorOpen);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const value = e.currentTarget.value;
    setInput((prevInput) => prevInput + value);
  };

  const handleClear = () => {
    setInput("");
    setResult("");
  };

  const handleEqual = () => {
    try {
      const node1 = math.parse(input);
      const evaluatedResult = node1.compile().evaluate();
      let number = evaluatedResult.toString().split(".")[1];
      if (number && number.length > 6) {
        number = evaluatedResult.toFixed(7).toString();
      } else {
        number = evaluatedResult.toString();
      }
      setInput(`${input}=`);
      setResult(number);
    } catch (error) {
      console.log(error);
      setInput("HATA");
    }
  };

  return (
    <>
      {isCalculatorOpen && (
        <Draggable nodeRef={nodeRef}>
          <div
            ref={nodeRef}
            className={`modal open withoutOverlay`}
            style={{
              top: "30%",
              left: "30%",
              transform: "translate(-50%, -50%) !important",
              position: "absolute",
            }}
          >
            <div className="modal-header">
              <button
                className="close-button"
                onClick={() => closeCalculator()}
              >
                <TimesIcon className={undefined} />
              </button>
            </div>
            <div className="calculator">
                <div className="display">{input}</div>
                <div className="display">
                  <span>{result}</span>
                </div>

                <button className="btn" onClick={handleClear}>
                  AC
                </button>
                <button className="btn" value="PI" onClick={handleClick}>
                  π
                </button>
                <button className="btn" value="%" onClick={handleClick}>
                  %
                </button>
                <button className="btn" value="*" onClick={handleClick}>
                  *
                </button>

                <button className="btn" value="7" onClick={handleClick}>
                  7
                </button>
                <button className="btn" value="8" onClick={handleClick}>
                  8
                </button>
                <button className="btn" value="9" onClick={handleClick}>
                  9
                </button>
                <button className="btn" value="/" onClick={handleClick}>
                  /
                </button>

                <button className="btn" value="4" onClick={handleClick}>
                  4
                </button>
                <button className="btn" value="5" onClick={handleClick}>
                  5
                </button>
                <button className="btn" value="6" onClick={handleClick}>
                  6
                </button>
                <button className="btn" value="-" onClick={handleClick}>
                  -
                </button>

                <button className="btn" value="1" onClick={handleClick}>
                  1
                </button>
                <button className="btn" value="2" onClick={handleClick}>
                  2
                </button>
                <button className="btn" value="3" onClick={handleClick}>
                  3
                </button>
                <button className="btn" value="+" onClick={handleClick}>
                  +
                </button>
                <button className="btn" value="^" onClick={handleClick}>
                  ^
                </button>
                <button className="btn" value="sqrt(" onClick={handleClick}>
                  √
                </button>
                <button className="btn" value="0" onClick={handleClick}>
                  0
                </button>
                <button className="btn" onClick={handleEqual}>
                  =
                </button>

                <button className="btn" value="." onClick={handleClick}>
                  .
                </button>

                <button className="btn" value="E" onClick={handleClick}>
                  e
                </button>
                <button className="btn" value="(" onClick={handleClick}>
                  (
                </button>
                <button className="btn" value=")" onClick={handleClick}>
                  )
                </button>
              </div>
          </div>
        </Draggable>
      )}
    </>
  );
};

export default Calculator;
